import { Clickable } from '@carvana/merch-components';

type OwnProps = {
  showBanner: boolean;
  onToggle: () => void;
};

export default function BannerToggle({ showBanner, onToggle }: OwnProps) {
  return (
    <Clickable
      element="span"
      onClick={onToggle}
      className="pointer-events-auto px-8 text-2xl leading-none"
      data-analytics-id="Toggle feature branch banner"
      data-testid="toggle-feature-branch-banner"
      title="Toggle feature branch banner"
    >
      {showBanner ? '–' : '+'}
    </Clickable>
  );
}
